import React from "react";
import { TrendBrickChart, periodsFromRows } from "./TrendBrickChart";

// Top-to-bottom stack order: level 4 on top, level 1 at the bottom. Mirrors
// the Student report's COLLAB_LEVELS; importing it here closes an import
// cycle through utils and routes.
const TIERS = [
  { key: "level_4_session_count", color: "#605DEC", short: "Lv4", name: "Exceeding Expectations" },
  { key: "level_3_session_count", color: "#00A35A", short: "Lv3", name: "Effective Collaborator" },
  { key: "level_2_session_count", color: "#EAB308", short: "Lv2", name: "Needs Guidance" },
  { key: "level_1_session_count", color: "#FE1E7E", short: "Lv1", name: "Needs Intervention" },
];

/**
 * Level counts per period, summed across the View By entities. At teacher and
 * school grain a brick is a session; at student grain it is one student's
 * session record.
 */
export const CollabTrendChart = ({ rows, trendBy }) => (
  <TrendBrickChart
    title="Collaboration Trend"
    yLabel="Session Count"
    tiers={TIERS}
    periods={periodsFromRows(rows, trendBy, TIERS, (row, key) => row[key] || 0)}
  />
);
